import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=b048d79e&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports